import React, {useState} from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {useDispatch, useSelector} from "react-redux";
import Languages from "../Language/Languages";
import {selectUserAccount, selectUserPictureUrl} from "../../stores/account/account.selectors";
import {useLogOutMutation} from "../../stores/account/account.api";
import {useNavigate} from "react-router-dom";

import './UserPanel.style.scss'
import Currency from "../Currency/Currency";
import {FormattedMessage} from "react-intl";
import Button from "@mui/material/Button";
import useAppModalService from "../../hooks/useAppModalService";
import SecureDepositPopUp from "../../views/PopUps/SecureDepositPopUp/SecureDepositPopUp";
import DropdownMenu from "../DropDownMenu/DropDownMenu";
import GlobalConst from "../../constants/GlobalConst";
import ChangePicturePopUp from "../../views/PopUps/ChangePicturePopUp/ChangePicturePopUp";
import {ModalType} from "../AppModal/ModalTypes";

export default function AccountMenu(props) {
    const navigate = useNavigate();
    const {openModal, closeModal, modalStack, stackSize} = useAppModalService();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const userAccount = useSelector(selectUserAccount);
    const [logOut] = useLogOutMutation();
    const userPicUrl = useSelector((state) => selectUserPictureUrl(state, userAccount.accountId));

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOpenChangePicturePopUp = async () => {
         await openModal('changePicture', 'info', {
                modalComponent: ChangePicturePopUp,
                onOk: () => console.log('OK clicked'),
                onCancel: () => console.log('Cancel clicked'),
                onClose: () => console.log('Close clicked'),
            });

    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        logOut();
        handleClose();
    };

    const handleMyAccountClick = (str) => {
        navigate(`/myaccount/${str}`);
        handleClose();
    };

    const handleRedirectMyAccountClick = (str) => {
        window.location.href = `${GlobalConst.SITE_URLS.TRADEFAN}/MyAccount/#${str}?pickx=1`;
        handleClose();
    }

    const handleDepositClick = async () => {
        if (GlobalConst.FEATURES.ADD_FUNDS)
            await openModal('deposit', ModalType.CUSTOM, {
                title: 'Secure Deposit',
                modalComponent: SecureDepositPopUp,
            });
    };

    return (
        <div className="AccountMenu">
           <Tooltip title="Account settings">
               <IconButton
                   className={"accountMenuButton"}
                   onClick={handleOpenChangePicturePopUp}
                   // onMouseEnter={handleClick}
                   size="small"
                   sx={{ml: 2}}
                   aria-controls={open ? 'account-menu' : undefined}
                   aria-haspopup="true"
                   aria-expanded={open ? 'true' : undefined}
               >
                   <Avatar sx={{width: 32, height: 32}} src={userPicUrl}>M</Avatar>
               </IconButton>
           </Tooltip>
            <DropdownMenu
                activator={
                   <div className="AccountInfo">
                       <Typography className={"pseudonym"}>
                           {userAccount?.pseudonym}
                           <KeyboardArrowDownIcon className='arrowDownIcon'
                                                  onClick={handleClick}
                                                  onMouseEnter={handleClick}/>
                       </Typography>
                       <Typography className={"availableBalance"}>
                           <Currency className="gold-gradient-text"
                                     value={ {".com": userAccount?.availableUSDBalance,
                                              ".mx": userAccount?.availableMXNBalance,
                                              ".fr": userAccount?.availableEuroBalance,
                                               }[GlobalConst.SITE_TLD]}
                                     />
                       </Typography>
                   </div>
                }>
                <div className="menu-item"
                     onClick={() => handleMyAccountClick("myprofile")}>
                    <FormattedMessage id={"navigationHeader.myAccount.myProfile"}/>
                </div>

                <div className="menu-item"
                     onClick={() => handleMyAccountClick("mypicks/ongoing")}>
                    <FormattedMessage id={"navigationHeader.myAccount.myPicks"}/>
                </div>

                <div className="menu-item"
                     onClick={() => GlobalConst.FEATURES.ENABLE_LEGACY_PAGES ? handleRedirectMyAccountClick('WithdrawFunds') : handleMyAccountClick("withdrawfunds")}>
                    <FormattedMessage id={"navigationHeader.myAccount.withdrawFunds"}/>
                </div>

                <div className="menu-item"
                     onClick={() => handleMyAccountClick("transactionhistory")}>
                    <FormattedMessage id={"navigationHeader.myAccount.transactions"}/>
                </div>

                <div className="menu-item">
                    <Languages/>
                </div>

                <div className="menu-item"
                     onClick={()=>handleLogout()}>
                    <FormattedMessage id={"navigationHeader.myAccount.logout"}/>
                </div>
            </DropdownMenu>

            <Button variant="outlined"
                    className={"depositButton"}
                    onClick={handleDepositClick}>
                <FormattedMessage id={"navigationHeader.deposit"}/>
            </Button>
        </div>
    );
}
